import { IMG } from "@/lib/content";
import { Reveal, MaskedLines } from "@/components/motion/Reveal";
import { Parallax } from "@/components/motion/Parallax";
import { Button } from "@/components/motion/Button";

const TARGETS = ["Immobilienverwaltungen", "Eigentümer", "Unternehmen", "Praxen", "Büros", "Retail", "Gewerbebetriebe"];

export function B2B() {
  return (
    <section className="relative bg-signal text-white grain" aria-labelledby="b2b-title">
      <div className="relative z-10 grid lg:grid-cols-12">
        <div className="lg:col-span-6 xl:col-span-5 container-x lg:pr-12 py-28 md:py-40 flex flex-col justify-between">
          <div>
            <Reveal>
              <p className="label text-white/70 mb-6 flex items-center gap-4"><span className="w-6 h-px bg-white/60" /> 07 · Liegenschaften & B2B</p>
            </Reveal>
            <MaskedLines as="h2" id="b2b-title" lines={["Für Liegenschaften,", "die gepflegt", "bleiben sollen."]} className="display text-4xl sm:text-5xl lg:text-6xl text-white" />
            <Reveal delay={0.2} className="mt-10 max-w-md">
              <p className="text-base md:text-lg text-white/85 leading-relaxed">
                Emini Reinigung übernimmt regelmässige und planbare Reinigungsarbeiten für Liegenschaften und Unternehmen. Klare Abläufe, feste Ansprechpartner und zuverlässige Ausführung schaffen langfristig gepflegte Objekte.
              </p>
            </Reveal>
          </div>
          <Reveal delay={0.3} className="mt-16">
            <ul className="flex flex-wrap gap-x-6 gap-y-3 label text-white/75 mb-12">
              {TARGETS.map((t) => <li key={t}>{t}</li>)}
            </ul>
            <Button to="/kontakt?typ=business" variant="light" data-testid="b2b-cta">B2B Anfrage</Button>
          </Reveal>
        </div>
        <div className="lg:col-span-6 xl:col-span-7 min-h-[60vw] lg:min-h-0">
          <Parallax src={IMG.b2b} alt="Moderne Bürofassade aus Glas" className="h-full min-h-[60vw] lg:min-h-[100%]" amount={8} sizes="(min-width:1024px) 58vw, 100vw" />
        </div>
      </div>
    </section>
  );
}
